exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-app {\n  border: none;\n  float: left;\n  text-decoration: none;\n  vertical-align: middle;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: -ms-flexbox;\n  display: flex;\n  text-align: center;\n  color: #FFF !important;\n  background-color: #0EBCDD;\n  -ms-flex-pack: space-evenly;\n  justify-content: space-evenly;\n  -ms-flex-align: center;\n  align-items: center;\n  transition-property: width border-radius;\n  transition-duration: 0.3s; }\n  .close-app i {\n    margin: auto auto !important;\n    color: white !important; }\n  .close-app:hover {\n    background-color: #1387A5; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/app/layout/layout.component.scss
// module id = ../../../../../src/app/layout/layout.component.scss
// module chunks = main